import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SearchInputComponent } from '../search-input/search-input.component';
import { BtnPrimaryComponent } from '../buttons/btn-primary/btn-primary.component';
import { FormGroup } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { SubmitOrderService } from '../../../services/submit-order/submit-order.service';
import {
  IDidCountries,
  IPackageCountries,
} from '../../../models/countries.model';
import { SearchCountriesService } from '../../../services/search-countries/search-countries.service';

@Component({
  selector: 'app-search-countries',
  standalone: true,
  imports: [SearchInputComponent, BtnPrimaryComponent, TranslocoModule],
  templateUrl: './search-countries.component.html',
  styleUrl: './search-countries.component.scss',
})
export class SearchCountriesComponent {
  didCountry: IDidCountries | null = null;
  packageCountry: IPackageCountries | null = null;

  submitOrderService = inject(SubmitOrderService);
  
  searchCountriesService = inject(SearchCountriesService);
  router = inject(Router);

  didCountries: IDidCountries[];
  packagesCountries: IPackageCountries[];

  countriesForm = this.submitOrderService.submitForm.get(
    'countriesForm'
  ) as FormGroup;

  constructor() {}

  async ngOnInit(): Promise<void> {
    this.countriesForm.reset();

    try {
      const data = await this.searchCountriesService.getCountriesData();
      this.didCountries = data.didCountries;
      this.packagesCountries = data.packagesCountries;
    } catch (error) {
      console.error('Error fetching countries data:', error);
      this.didCountries = [];
      this.packagesCountries = [];
    }
  }

  onDidCountrySelected(country: IDidCountries) {
    this.countriesForm.get('didCountryName')?.setValue(country.countryName);
    this.countriesForm.get('didCountryId')?.setValue(country.countryID);
    this.didCountry = country;
  }

  onPackageCountrySelected(country: IPackageCountries) {
    this.countriesForm.get('packageCountryName')?.setValue(country.countryName);
    this.countriesForm.get('packageCountryId')?.setValue(country.countryId);
    this.packageCountry = country;
  }

  navigateToChooseNumber(): void {
    if (this.countriesForm.invalid) {
      return;
    }

    const didCountryName = this.didCountry?.countryName.toLowerCase().replaceAll(" ", "-");
    const packageCountryName = this.packageCountry?.countryName.toLowerCase().replaceAll(" ", "-");

    if (didCountryName && packageCountryName) {
      this.router.navigate([`/choose-your-number/${didCountryName}/${packageCountryName}`])
    } else {
      console.error('Invalid country selection. Navigation aborted.');  
    } 
  }
}
